import { Card, Tag } from 'antd';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import { EditOutlined, ExportOutlined } from '@ant-design/icons';
import { STATUS_COLORS } from '../helpers/constants';
import { capitalize, getCardBGColor, isMainCleaning } from '../helpers/helpers';

const Task = ({ task, index, handleEditTask, taskType }) => {
    const { id, duration, hotelApartment, title, start, deadline, status } =
        task;

    return (
        <Draggable
            draggableId={`${taskType}-task-${id}`}
            index={index}
            key={`${taskType}-task-${id}`}
        >
            {(provided, snapshot) => (
                <Card
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                        ...provided.draggableProps.style,
                        marginBottom: '8px',
                        boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.1)',
                        backgroundColor: snapshot.isDragging
                            ? '#fef2e8'
                            : getCardBGColor(start, deadline),

                        color: '#b73522',
                    }}
                >
                    {hotelApartment && (
                        <h2
                            style={{
                                textAlign: 'center',
                                fontSize: 19,
                                marginBottom: 4,
                                marginTop: 10
                            }}
                        >
                            {hotelApartment}
                        </h2>
                    )}
                    <p
                        style={{
                            textAlign: 'center',
                            marginBottom: 8,
                            fontWeight:'bold'
                        }}
                    >
                        {duration} Min
                    </p>

                    <p>{title}</p>
                    <p>Start: {start}</p>
                    {deadline !== 'Invalid Date' && (
                        <p
                            style={{
                                textDecoration: 'underline',
                                fontWeight: isMainCleaning(title) ? 'bold' : 'normal',
                            }}
                        >
                            MFB: {deadline}
                        </p>
                    )}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 10,
                            position: 'absolute',
                            top: -2,
                            right: -2,
                        }}
                    >
                        <span
                            style={{
                                height: '10px',
                                width: '10px',
                                backgroundColor: STATUS_COLORS[status],
                                borderRadius: '50%',
                                display: 'inline-block',
                                marginRight: '5px',
                            }}
                        ></span>
                        <Tag color={STATUS_COLORS[status]}>
                            {capitalize(status)}
                        </Tag>
                    </div>
                    <a
                        href={`https://app.guesty.com/tasks/${id}/comments`}
                        target='_blank'
                        rel='noreferrer'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 10,
                            position: 'absolute',
                            top: 0,
                            left: 8,
                            color: 'inherit',
                        }}
                    >
                        <ExportOutlined />
                    </a>
                    <EditOutlined
                        onClick={() => handleEditTask(task)}
                        style={{ marginLeft: 'auto' }}
                    />
                </Card>
            )}
        </Draggable>
    );
};

Task.propTypes = {
    index: PropTypes.number.isRequired,
    task: PropTypes.object.isRequired,
    handleEditTask: PropTypes.func.isRequired,
    taskType: PropTypes.string.isRequired,
};

export default Task;
